import ApiService from "../ApiService";

const { REACT_APP_REST_ENDPOINT } = process.env;

/**
 * SafetyLicenzeService
 * Client API per licenze e autorizzazioni aziendali (art. 134 TULPS,
 * regolamento di servizio, certificazioni UNI/ISO, polizze RC...) con scadenze.
 */
export default class SafetyLicenzeService {
    /**
     * Catalogo tipi licenza, filtrato per settore.
     * @param {number} [id_azienda] deriva il settore dall'azienda.
     * @param {string} [settore] settore singolo o CSV.
     */
    static getTipi = (id_azienda = "", settore = "") => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/licenze/tipi`;
            const payload = {};
            if (id_azienda) payload.id_azienda = id_azienda;
            if (settore) payload.settore = settore;
            ApiService.postRequest(resolve, reject, url, payload);
        });
    };

    /** Licenze di un'azienda. */
    static byAzienda = (id_azienda) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/licenze/byAzienda`;
            ApiService.postRequest(resolve, reject, url, { id_azienda });
        });
    };

    /** Crea una licenza (FormData con eventuale file). */
    static create = (formData) => {
        const url = `${REACT_APP_REST_ENDPOINT}/safety/licenze/create`;
        return ApiService.postFormData(url, formData);
    };

    /** Elimina (soft) una licenza. */
    static deleteLicenza = (id_licenza) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/licenze/delete`;
            ApiService.postRequest(resolve, reject, url, { id_licenza });
        });
    };

    /** Scarica il file di una licenza. */
    static download = (id_licenza, filename) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/licenze/download`;
            ApiService.postRequestWithDownload(resolve, reject, url, { id_licenza, filename });
        });
    };
}
